import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
// import HomeIntorVideo from "../../../Components/Modal/supplier_app/HomeIntro/HomeIntorVideo";
import HomeCategorieDetails from "../../../Components/Modal/supplier_app/HomeIntro/HomeCategorieDetails";
import LoaderSmall from "../../../Components/LoaderSmall";
import CustomerConstants from "../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";

import customerItemService from "../../../services/customer_appCommonService";
import toast from "react-hot-toast";
import { formatToTwoDigits } from "../../../common/Validations";

//Redux
import { useSelector } from "react-redux"; //useDispatch

const HomeIntro = () => {
  const currentDate = new Date();
  localStorage.setItem("menu", "Home");
  localStorage.setItem("submenu", "-");
  const navigate = useNavigate();

  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store
  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const navigateToMainPage = (page) => {
    if (page === "totalOrderCount") {
      navigate(CustomerConstants.CUSTOMER_V1_ORDER_BOOKING_LIST);
    } else if (page === "orderCompletedCount") {
      navigate(CustomerConstants.CUSTOMER_V1_ORDER_COMPLETE_SCHEDULING_LIST);
    } else if (page === "confirmedDispatchCount") {
      navigate(CustomerConstants.CUSTOMER_V1_DISPATCH_CONFIRMATION_LIST);
    } else if (page === "totalUserCount") {
      navigate(CustomerConstants.CUSTOMER_V1_CUSTOMER_MASTER_LIST);
    }
  };

  const [totalUserCount, setTotalUserCount] = useState("");
  const [totalUserCountStatus, setTotalUserCountStatus] = useState(false);

  const [confirmedDispatchCount, setConfirmedDispatchCount] = useState("");
  const [confirmedDispatchStatus, setConfirmedDispatchStatus] = useState(false);

  const [orderCompletedCount, setOrderCompletedCount] = useState("");
  const [orderPendingCount, setPendingCount] = useState("");
  const [orderCompletedStatus, setOrderCompletedStatus] = useState(false);

  const [totalOrderCount, setTotalOrderCount] = useState("");
  const [totalOrderCountStatus, setTotalOrderStatus] = useState(false);

  const [totalPostDispatchCount, setTotalPostDispatchCount] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [totalPostDispatchCountStatus, setTotalPostDispatchCountStatus] =
    useState(false);

  // loadOrderCount
  const loadOrderCount = async () => {
    setTotalOrderStatus(true);
    let obj = {
      queryName: "GetTotalOrderCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalOrderCount(item.data);

        loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalOrderStatus(false);
  };

  // loadOrderCompletedCount
  const loadOrderCompletedCount = async (totalOrderCountVal) => {
    setOrderCompletedStatus(true);
    let obj = {
      queryName: "totalOrderCompletedCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setOrderCompletedCount(item.data);
        let orderComplete = item.data;
        setPendingCount(totalOrderCountVal - orderComplete);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setOrderCompletedStatus(false);
  };

  // loadConfirmedDispatchCount
  const loadConfirmedDispatchCount = async () => {
    setConfirmedDispatchStatus(true);
    let obj = {
      queryName: "totalConfirmedDispatchCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setConfirmedDispatchCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setConfirmedDispatchStatus(false);
  };

  // loadCustomerCount
  const loadCustomerCount = async () => {
    setTotalUserCountStatus(true);
    let obj = {
      queryName: "totalCustomerCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalUserCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalUserCountStatus(false);
  };

  const loadPostDispatchCount = async () => {
    setTotalPostDispatchCountStatus(true);
    let obj = {
      queryName: "totalPostDispatchCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalPostDispatchCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalPostDispatchCountStatus(false);
  };

  useEffect(() => {
    loadOrderCount();
    loadPostDispatchCount();
    loadConfirmedDispatchCount();
    loadCustomerCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Format the date (optional)
  const formattedDate = currentDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  // const [getIntroVideo, setIntroVideo] = useState(false);
  const [getCategoryDetail, setCategoryDetail] = useState(false);
  const [hideItem, setHideItem] = useState(false);

  // const [getVideoPath, setVideoPath] = useState();

  // const introVideoShow = (getVideoPath) => {
  //   setIntroVideo(true);
  //   setVideoPath(getVideoPath)
  // };

  // const introVideoHide = () => {
  //   setIntroVideo(false);
  // };

  // eslint-disable-next-line no-unused-vars
  const categoryDetailShow = () => {
    // setCategoryDetail(true);
  };

  const categoryDetailHide = () => {
    setCategoryDetail(false);
  };

  useEffect(() => {
    const userRole = userData?.roles?.[0]?.roleId || null;

    if (userRole === "CUSTOMER") {
      setHideItem(true);
    } else {
      setHideItem(false);
    }
    // console.log(">> userRole", userRole);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  return (
    <main className="dashboard main customer" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row className="home-intro">
              <Col xs={12} md={12} lg={12} className="headers p-2 mb-2">
                <Row>
                  <Col xs={12} md={2} lg={2}>
                    <div className="welcome">
                      <p>Welcome to</p>
                      <span>Product Lifecycle Management</span>
                    </div>
                  </Col>
                  <Col
                    xs={12}
                    md={8}
                    lg={8}
                    className="d-flex justify-content-center"
                  >
                    <div className="d-flex justify-content-start align-times-end">
                      <img
                        className="img-fluid introCustomerlogo"
                        src={appConfig?.customerLogo1}
                        alt="logo1"
                      />
                      <p className="fw-bold ms-2 fs-2">
                        {appConfig?.customerName}
                      </p>
                      {appConfig?.customerLogo2 && (
                        <img
                          className="img-fluid"
                          src={appConfig?.customerLogo2}
                          alt="logo2"
                        />
                      )}
                    </div>
                  </Col>
                  <Col xs={12} md={2} lg={2}>
                    <div className="date commTopButtonRightLeftPadding">
                      {/* <p>Today Date:</p> */}
                      <InputField
                        className="inputBox"
                        label=""
                        name="Fuels"
                        id="Fuels"
                        placeholder=""
                        // type="date"
                        value={formattedDate}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col xs={12} md={12} lg={12} className="card mb-2">
                {/* <p className="title p-2 mb-0">Overview</p> */}

                <div className="row">
                  <div className="col-lg-3 commTopButtonRightLeftPadding">
                    <div className="card info-card sales-card">
                      <div className="card-body">
                        <h5 className="card-title">
                          Orders
                          {/* <span>| Today</span> */}
                        </h5>

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-boxes"></i>
                          </div>
                          <div className="ps-3">
                            <LoaderSmall isLoading={totalOrderCountStatus} />
                            <h6>
                              {!totalOrderCountStatus
                                ? formatToTwoDigits(totalOrderCount || 0)
                                : ""}
                            </h6>
                            {/* <span className="text-success small pt-1 fw-bold">
                            12%
                          </span>{" "} */}
                            <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span>
                            <span
                              className="text-muted small pt-2 ps-1"
                              onClick={() =>
                                navigateToMainPage("totalOrderCount")
                              }
                            >
                              <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 commTopButtonRightLeftPadding">
                    <div className="card info-card revenue-card">
                      <div className="card-body">
                        <h5 className="card-title">
                          Completed / Pending
                          {/* <span>| This Month</span> */}
                        </h5>

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-box-seam"></i>
                          </div>
                          <div className="ps-3">
                            <LoaderSmall isLoading={orderCompletedStatus} />
                            <h6>
                              {!orderCompletedStatus
                                ? formatToTwoDigits(orderCompletedCount || 0) +
                                  " / " +
                                  formatToTwoDigits(orderPendingCount || 0)
                                : ""}
                            </h6>
                            {/* <span className="text-success small pt-1 fw-bold">
                            12%
                          </span>{" "} */}
                            <span className="text-muted small pt-2 ps-1">
                              Order Counts
                            </span>
                            <span
                              className="text-muted small pt-2 ps-1"
                              onClick={() =>
                                navigateToMainPage("orderCompletedCount")
                              }
                            >
                              <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 commTopButtonRightLeftPadding">
                    <div className="card info-card customers-card">
                      <div className="card-body">
                        <h5 className="card-title">
                          Dispatch / Confimed
                          {/* <span>| This Year</span> */}
                        </h5>

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-truck"></i>
                          </div>
                          <div className="ps-3">
                            <LoaderSmall isLoading={confirmedDispatchStatus} />
                            <h6>
                              {!confirmedDispatchStatus
                                ? formatToTwoDigits(
                                    totalPostDispatchCount || 0
                                  ) +
                                  " / " +
                                  formatToTwoDigits(confirmedDispatchCount || 0)
                                : ""}
                            </h6>
                            {/* <span className="text-success small pt-1 fw-bold">
                            12%
                          </span>{" "} */}
                            <span className="text-muted small pt-2 ps-1">
                              Count
                            </span>
                            <span
                              className="text-muted small pt-2 ps-1"
                              onClick={() =>
                                navigateToMainPage("confirmedDispatchCount")
                              }
                            >
                              <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {!hideItem && (
                    <div className="col-lg-3 commTopButtonRightLeftPadding">
                      <div className="card info-card customers-card">
                        <div className="card-body">
                          <h5 className="card-title">
                            Customers
                            {/* <span>| This Year</span> */}
                          </h5>

                          <div className="d-flex align-items-center">
                            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                              <i className="bi bi-people"></i>
                            </div>
                            <div className="ps-3">
                              <LoaderSmall isLoading={totalUserCountStatus} />
                              <h6>
                                {!totalUserCountStatus
                                  ? formatToTwoDigits(totalUserCount || 0)
                                  : ""}
                              </h6>
                              {/* <span className="text-success small pt-1 fw-bold">
                            12%
                          </span>{" "} */}
                              <span className="text-muted small pt-2 ps-1">
                                Total Count
                              </span>
                              <span
                                className="text-muted small pt-2 ps-1"
                                onClick={() =>
                                  navigateToMainPage("totalUserCount")
                                }
                              >
                                <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Col>
              <Col xs={12} md={12} lg={12} className="mb-2">
                <Row className="homeintroposter">
                  <Col
                    xs={12}
                    md={6}
                    lg={6}
                    className="postertext d-flex justify-content-center align-items-center pb-2"
                  >
                    <img
                      className="img-fluid"
                      src="./assets/img/meterial_img/M04.png"
                      alt="supplychiain"
                      width={"100%"}
                      style={{ height: "460px" }}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={6}
                    lg={6}
                    className="postertext d-felx justify-content-center align-items-center"
                  >
                    <p className="fw-bold ms-2 fs-3">Products</p>
                    <div className="smarthub">
                      <p className="fs-5 fw-bold ms-2">
                        Synthetic Fabric, Nylon Zippers, Metal Buttons, Lycra
                        Fabric, Wool Yarn
                      </p>
                    </div>
                    <Row>
                      <Col
                        xs={4}
                        md={4}
                        lg={4}
                        className="d-flex flex-column  align-items-center"
                      >
                        <img
                          className="img-fluid p-2"
                          src="./assets/img/meterial_img/M02.png"
                          alt="m-sand"
                          width={"100%"}
                          style={{ height: "160px" }}
                        />
                        <p className="fs-5 fw-bold m-0">Denim Fabric</p>
                      </Col>
                      <Col
                        xs={4}
                        md={4}
                        lg={4}
                        className="d-flex flex-column  align-items-center"
                      >
                        <img
                          className="img-fluid p-2"
                          src="./assets/img/meterial_img/M04.png"
                          alt="20mm"
                          width={"100%"}
                          style={{ height: "160px" }}
                        />
                        <p className="fs-5 fw-bold m-0">Metal Buttons</p>
                      </Col>
                      <Col
                        xs={4}
                        md={4}
                        lg={4}
                        className="d-flex flex-column  align-items-center"
                      >
                        <img
                          className="img-fluid p-2"
                          src="./assets/img/meterial_img/M05.png"
                          alt="supplychiain"
                          width={"100%"}
                          style={{ height: "160px" }}
                        />
                        <p className="fs-5 fw-bold m-0">Metal Buttons</p>
                      </Col>
                      <Col
                        xs={4}
                        md={4}
                        lg={4}
                        className="d-flex flex-column  align-items-center"
                      >
                        <img
                          className="img-fluid p-2"
                          src="./assets/img/meterial_img/M06.png"
                          alt="p-sand"
                          width={"100%"}
                          style={{ height: "160px" }}
                        />
                        <p className="fs-5 fw-bold m-0">Nylon Zippers</p>
                      </Col>
                      <Col
                        xs={4}
                        md={4}
                        lg={4}
                        className="d-flex flex-column  align-items-center"
                      >
                        <img
                          className="img-fluid p-2"
                          src="./assets/img/meterial_img/M07.png"
                          alt="gsb"
                          width={"100%"}
                          style={{ height: "160px" }}
                        />
                        <p className="fs-5 fw-bold m-0">Wool Yarn</p>
                      </Col>

                      <Col
                        xs={4}
                        md={4}
                        lg={4}
                        className="d-flex flex-column  align-items-center"
                      >
                        <img
                          className="img-fluid p-2"
                          src="./assets/img/meterial_img/M08.png"
                          alt="p-sand"
                          width={"100%"}
                          style={{ height: "160px" }}
                        />
                        <p className="fs-5 fw-bold m-0">Synthetic Fabric</p>
                      </Col>
                    </Row>
                    {/* <div className="smarthub">                      
                      <p>Intelligent, Scalable, Empowering</p>
                    </div> */}
                    {/* <p>
                      Your all-in-one solution for optimizing <br /> operations
                      and maximizing productivity
                    </p> */}
                  </Col>
                </Row>
              </Col>
              {/* <Col xs={12} md={12} lg={12} className="mb-2">
                <Row>
                  <Col xs={12} md={12} lg={12} className="mb-2">
                    <div className="card m-0">
                      <div className="card-body">
                        <p className="title card-title">Notification</p>

                        <div
                          className="alert border-dark alert-dismissible fade show"
                          role="alert"
                        >
                          <p>A simple primary outlined alert—check it out!</p>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="alert"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div
                          className="alert border-dark alert-dismissible fade show"
                          role="alert"
                        >
                          <p>A simple primary outlined alert—check it out!</p>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="alert"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div
                          className="alert border-dark alert-dismissible fade show"
                          role="alert"
                        >
                          <p>A simple primary outlined alert—check it out!</p>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="alert"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div
                          className="alert border-dark alert-dismissible fade show"
                          role="alert"
                        >
                          <p>A simple primary outlined alert—check it out!</p>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="alert"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div
                          className="alert border-dark alert-dismissible fade show"
                          role="alert"
                        >
                          <p>A simple primary outlined alert—check it out!</p>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="alert"
                            aria-label="Close"
                          ></button>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={12} lg={12}>
                    <div className="card m-0 ">
                      <div className="card-body">
                        <h5 className="My Team card-title">My Team</h5>

                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Name</th>
                              <th scope="col">Position</th>
                              <th scope="col">Categorie</th>
                              <th scope="col">Start Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th scope="row">1</th>
                              <td>Brandon Jacob</td>
                              <td>Designer</td>
                              <td>28</td>
                              <td>2016-05-25</td>
                            </tr>
                            <tr>
                              <th scope="row">2</th>
                              <td>Bridie Kessler</td>
                              <td>Developer</td>
                              <td>35</td>
                              <td>2014-12-05</td>
                            </tr>
                            <tr>
                              <th scope="row">3</th>
                              <td>Ashleigh Langosh</td>
                              <td>Finance</td>
                              <td>45</td>
                              <td>2011-08-12</td>
                            </tr>
                            <tr>
                              <th scope="row">4</th>
                              <td>Angus Grady</td>
                              <td>HR</td>
                              <td>34</td>
                              <td>2012-06-11</td>
                            </tr>
                            <tr>
                              <th scope="row">5</th>
                              <td>Raheem Lehner</td>
                              <td>Dynamic Division Officer</td>
                              <td>47</td>
                              <td>2011-04-19</td>
                            </tr>
                            <tr>
                              <th scope="row">6</th>
                              <td> Lehner Raheem </td>
                              <td>Dynamic Division Officer</td>
                              <td>47</td>
                              <td>2011-04-19</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} md={12} lg={12} className="headers mb-2">
                <p className="title p-2">Process</p>
                <div className="d-flex overflow-auto">
                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Vendor Management</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">     
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Procurement</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-file-earmark-check"></i>
                          </div>
                          <h5 className="card-title">Sourcing</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-card-list"></i>
                          </div>
                          <h5 className="card-title">Contract</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Auction</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/Spend_Analysis.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Spend Analysis</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={12} lg={12}>
                <div className="card">
                  <div className="card-body pb-0">
                    <p className="title card-title">
                      News &amp; Updates <span>| Today</span>
                    </p>
                    <div className="news">
                      <div className="post-item clearfix">
                        <img src="assets/img/news-1.jpg" alt="" />

                        <h4>
                          <span>Nihil blanditiis at in nihil autem</span>
                        </h4>
                        <p>
                          Sit recusandae non aspernatur laboriosam. Quia enim
                          eligendi sed ut harum...
                        </p>
                      </div>

                      <div className="post-item clearfix">
                        <img src="assets/img/news-2.jpg" alt="" />
                        <h4>
                          <span>Quidem autem et impedit</span>
                        </h4>
                        <p>
                          Illo nemo neque maiores vitae officiis cum eum turos
                          elan dries werona nande...
                        </p>
                      </div>

                      <div className="post-item clearfix">
                        <img src="assets/img/news-3.jpg" alt="" />
                        <h4>
                          <span >
                            Id quia et et ut maxime similique occaecati ut
                          </span>
                        </h4>
                        <p>
                          Fugiat voluptas vero eaque accusantium eos.
                          Consequuntur sed ipsam et totam...
                        </p>
                      </div>

                      <div className="post-item clearfix">
                        <img src="assets/img/news-4.jpg" alt="" />
                        <h4>
                          <span>Laborum corporis quo dara net para</span>
                        </h4>
                        <p>
                          Qui enim quia optio. Eligendi aut asperiores enim
                          repellendusvel rerum cuder...
                        </p>
                      </div>

                      <div className="post-item clearfix">
                        <img src="assets/img/news-5.jpg" alt="" />
                        <h4>
                          <span>
                            Et dolores corrupti quae illo quod dolor
                          </span>
                        </h4>
                        <p>
                          Odit ut eveniet modi reiciendis. Atque cupiditate
                          libero beatae dignissimos eius...
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col> */}
            </Row>
          </div>
        </Col>
      </Row>
      {/* <HomeIntorVideo show={getIntroVideo} onHide={introVideoHide} videopath={getVideoPath} /> */}
      <HomeCategorieDetails
        show={getCategoryDetail}
        onHide={categoryDetailHide}
      />
    </main>
  );
};
export default HomeIntro;
